module.exports = __webpack_public_path__ + "img/img.5a5f6122.png";